import { BrokerNerdsBarkerCoreEnumsMarketplace } from '../api';
import { MarketplaceNames } from '../models/marketplaces';

const TENANT_MARKETPLACE_PRIORITY = [
  BrokerNerdsBarkerCoreEnumsMarketplace.SeatGeek,
  BrokerNerdsBarkerCoreEnumsMarketplace.Ticketmaster,
  BrokerNerdsBarkerCoreEnumsMarketplace.TicketEvolution,
  BrokerNerdsBarkerCoreEnumsMarketplace.Ticombo,
  BrokerNerdsBarkerCoreEnumsMarketplace.TicketNetwork,
] as const;

export function getStandardMarketplaceName(name?: string): MarketplaceNames {
  if (!name) {
    return 'Other';
  }

  const lowerName = name.toLowerCase();

  if (lowerName.includes('geek')) {
    return 'SeatGeek';
  }

  if (lowerName.includes('stub') || lowerName.includes('viagogo')) {
    return 'StubHub';
  }

  if (lowerName.includes('axs') || lowerName.includes('pdn')) {
    return 'AXS';
  }

  if (lowerName.includes('vivid') || lowerName.includes('fanx')) {
    return 'Vivid Seats';
  }

  if (lowerName.includes('ticketsnow') || lowerName.includes('tnow') || lowerName.includes('event inventory') || lowerName.includes('ticketmaster') || lowerName.includes('tm')) {
    return 'Ticketmaster';
  }

  if (lowerName.includes('pick')) {
    return 'TickPick';
  }

  if (lowerName.includes('evo')) {
    return 'TEVO';
  }

  if (lowerName.includes('gametime')) {
    return 'Gametime';
  }

  if (lowerName.includes('ticket network') || lowerName.includes('tnd') || lowerName.includes('ticketnetwork') || lowerName.includes('mercury')) {
    return 'TicketNetwork';
  }

  if (lowerName.includes('goticket') || lowerName.includes('go ticket')) {
    return 'GoTickets';
  }

  return 'Other';
}

export function getDefaultMarketplaceForTenant(
  availableMarketplaces: BrokerNerdsBarkerCoreEnumsMarketplace[] | null | undefined,
  principalDefaultMarketplace?: BrokerNerdsBarkerCoreEnumsMarketplace | null,
) {
  const tenantMarketplaces = [...new Set(availableMarketplaces ?? [])];

  if (principalDefaultMarketplace && tenantMarketplaces.includes(principalDefaultMarketplace)) {
    return principalDefaultMarketplace;
  }

  const prioritizedMarketplace = TENANT_MARKETPLACE_PRIORITY.find((marketplace) => tenantMarketplaces.includes(marketplace));
  return prioritizedMarketplace ?? tenantMarketplaces[0] ?? BrokerNerdsBarkerCoreEnumsMarketplace.SeatGeek;
}
